import { createSelector } from 'reselect';

const getConfiguredCurrenciesData = (state: any) =>
    state.generalConfigProviderReducer.defaultConfiguredCurrencies;

export const getDefConfiguredCurrencies = createSelector(
    getConfiguredCurrenciesData,
    (state) => state,
);
